import {
  ADD_CHITTIE_PAYMENT_STARTED,
  ADD_CHITTIE_PAYMENT_COMPLETED,
  ADD_CHITTIE_PAYMENT_ERROR,
  FETCH_CHITTIE_PAYMENT_STARTED,
  FETCH_CHITTIE_PAYMENT_COMPLETED,
  FETCH_CHITTIE_PAYMENT_ERROR,
  UPDATE_CHITTIE_PAYMENT_STARTED,
  UPDATE_CHITTIE_PAYMENT_COMPLETED,
  UPDATE_CHITTIE_PAYMENT_ERROR,
  CLEAR_PAYMENTS,
} from '../actionTypes/chittiePaymentActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  chittiePayments: {}
};

function chittiePaymentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_CHITTIE_PAYMENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_CHITTIE_PAYMENT_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_CHITTIE_PAYMENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_CHITTIE_PAYMENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_CHITTIE_PAYMENT_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          chittiePayments: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_CHITTIE_PAYMENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case UPDATE_CHITTIE_PAYMENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case UPDATE_CHITTIE_PAYMENT_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case UPDATE_CHITTIE_PAYMENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case CLEAR_PAYMENTS: {
      return {
        ...state,
        chittiePayments: {},
        submitted: false,
        success: true
      };
    }
    default:
      return state;
  }
}

export default chittiePaymentReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/chittiePaymentReducer.js